export enum IconsEnum {
    TURN_SOUND_ON = 'turn-sound-on',
}